<template>
    <g v-if="isMobile && isNotLanding" pointer-events="visible">
        <minimize-svg
            v-if="isFullscreen"
            key="fullscreen_exit"
            class="icon"
            :x="x"
            :y="y"
            :width="size"
            :height="size"
            fill="#ffffff"
            fill-opacity="0.5"
            @click="toggleFullScreen"
        ></minimize-svg>
        <maximize-svg
            v-else
            key="fullscreen"
            class="icon"
            :x="x"
            :y="y"
            :width="size"
            :height="size"
            fill="#ffffff"
            @click="toggleFullScreen"
        ></maximize-svg>
    </g>
</template>

<script>
import { mapState } from 'vuex'

/*
    Material Icons
*/
import MaximizeSvg from '@/assets/svg/baseline-fullscreen-24px.svg'
import MinimizeSvg from '@/assets/svg/baseline-fullscreen_exit-24px.svg'
/* 
    Feather Icons
*/
// import MaximizeSvg from '@/assets/svg/maximize.svg'
// import MinimizeSvg from '@/assets/svg/minimize.svg'

export default {
    data() {
        return {
            isFullscreen: false
        }
    },

    components: {
        MaximizeSvg,
        MinimizeSvg
    },

    computed: {
        ...mapState(['w', 'h']),

        isNotLanding: vm => vm.$store.state.scene !== 'landing',

        isMobile: vm => vm.w < 500,
        // isMobile: _ => true,

        size: vm => 48,

        margin: vm => ({
            bottom: vm.h % 10,
            right: 20 + (vm.w % 10)
        }),

        x: vm => vm.w - vm.margin.right - vm.size,
        y: vm => vm.h - vm.margin.bottom - vm.size
        // y: vm => 0
    },

    methods: {
        toggleFullScreen() {
            if (!this.isFullscreen) {
                requestFullScreen.call(docEl)
                this.isFullscreen = true
            } else {
                cancelFullScreen.call(doc)
                this.isFullscreen = false
            }
        }
    }
}

/*
    For going full screen. Taken form:
    https://developers.google.com/web/fundamentals/native-hardware/fullscreen/
*/
const doc = window.document
const docEl = doc.documentElement
const requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.msRequestFullscreen
const cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen
</script>

<style lang="stylus">
.icon
    cursor: pointer
</style>



